import React from 'react';

import Button from '@/components/Button';
import { WizardStep } from '@/components/Wizard';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';

import RichUI from '@/ui-kit/rich-text/RichUI/RichUI';

import styles from './ClaimBookingStep.module.scss';

type ClaimBookingOtpLockedProps = {
  tabId: string;
  onCancel: () => void;
};

const ClaimBookingOtpLocked: React.FC<ClaimBookingOtpLockedProps> = ({ tabId, onCancel }) => {
  const appUiData = useAppUiData();

  return (
    <WizardStep tabId={tabId}>
      <div className={styles.lockedContainer}>
        <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.otpLockedTitle]}</h2>
        <p className={styles.otpLockedBody}>
          <RichUI code={appUiData[appUiIds.claimBooking.otpLockedBody]} useRichText={false} />
        </p>
        <Button variant="primary" onClick={onCancel} className={styles.gotoBtn}>
          {appUiData[appUiIds.claimBooking.otpLockedCTA]}
        </Button>
      </div>
    </WizardStep>
  );
};

export default ClaimBookingOtpLocked;
